import validator from 'utils/validator';

validator.init();
